import {useRef,useState,createRef} from 'react';
import {Button, Table, Spin, Modal, Tabs, DatePicker,Select} from 'antd';
import Header from '../../../components/HeaderList';
import {ReactComponent as Edit} from '../../../assets/icons/edit.svg';
import {ReactComponent as Trash} from '../../../assets/icons/trash.svg';
import {getColumnSearchProps} from '../../../utils/tables';
import styles from '../styles/HomeUI.module.css';
import { Chart } from "react-google-charts";
import locale from 'antd/es/date-picker/locale/es_ES';
import XLSX from 'xlsx';
import { renderToString } from 'react-dom/server';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;


const HomeUI = props => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [periodo, setPeriodo] = useState("Últimos 7 días");
  const tableDepartamentosRef = createRef();
  const tableTopicsRef = createRef();
  const tablePersonalRef = createRef();
  const tableRestauranteRef = createRef();
  const tableGerenteAreaRef = createRef();

  const [activeTab, setActiveTab] = useState('1');

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const searchInput = useRef(null);
  const dateFormat = 'DD/MM/YYYY';
  const customFormat = (value) => `${value.format(dateFormat)}`;

  const onChangeFecha = (date, dateString) => {
    console.log(date, dateString);
    setStartDate(dateString[0])
    setEndDate(dateString[1])
  };

  const {
    loading,
    dataDepartamento,
    dataTipificacion,
    dataPersonal,
    dataRestaurante,
    dataGerenteZona,
    users,
    datagrafica,
    buscarTickets
  } = props;

  const getUser = () => {
    const localities = [];
    users.map(d => {
      localities.push({
        text: d.nombre + " " +  d.apellido,
        value: d.nombre + " " +  d.apellido,
      });
    });
    return localities;
  };

  const geUserName = locality => {
   
    let name = "-";
    const index = users.findIndex(el => el.nombre + " " + el.apellido === locality);
    if (index > -1) {
      name = users[index].nombre + " " +  users[index].apellido;
    }
    return name;
  };
 

  const toHoursAndMinutes = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    return `${(hours)}:${(minutes)}`;
  }

  const padToTwoDigits = (num) => {
    return num.toString().padStart(2, '0');
  }

  const secondsToHms = (d) => {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var mShow = m < 10 ? "0"+m : m

    var hDisplay = h > 0 ? h + (h == 1 ? " hora, " : " horas, ") : "";
    var mDisplay = m > 0 ? mShow + (m == 1 ? " minuto, " : " minutos, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " segundo" : " segundos") : "";

    if(h>0){
      return h + ":" + mShow +  " horas"; 
    }else if(m>0){
      return m > 0 ? mShow + (m == 1 ? " minuto " : " minutos ") : "";; 
    }else{
      return hDisplay + mDisplay + sDisplay; 
    }
    
  }

  const columns = [
    {
      title: 'Departamentos',
      dataIndex: 'nombre',
      align: 'center',
    },
    {
      title: 'Abiertos',
      dataIndex: 'abiertos',
      sorter: (a, b) => a.abiertos - b.abiertos,
    },
    {
      title: 'Asignados',
      dataIndex: 'asignados',
      sorter: (a, b) => a.asignados - b.asignados,
    },
    {
      title: 'Atrasados',
      dataIndex: 'atrasados',
      sorter: (a, b) => a.atrasados - b.atrasados,
    },
    {
      title: 'Finalizados',
      dataIndex: 'finalizados',
      sorter: (a, b) => a.finalizados - b.finalizados,
    },
    {
      title: 'Tickets',
      dataIndex: 'totalTicket',
      sorter: (a, b) => a.totalTicket - b.totalTicket,
    },
    {
      title:  (
        <div>
          Tiempo en<br/>asignarse
        </div>
      ),
      dataIndex: 'tiempoAsignarse',
      align: 'left',
      render: (id, record) => (
        <div>
         {record.tiempoAsignarse != undefined ? secondsToHms(record.tiempoAsignarse) : "-"}
        </div>
      ),
    },
    {
      title:  (
        <div>
          Tiempo de<br/>inicio
        </div>
      ),
      dataIndex: 'tiempoIniciar',
      align: 'left',
      render: (id, record) => (
        <div>
         {record.tiempoIniciar != undefined ? secondsToHms(record.tiempoIniciar) : "-"}
        </div>
      ),
    },
    {
      title:  (
        <div>
          Tiempo de<br/>finalización
        </div>
      ),
      dataIndex: 'tiempoFinalizado',
      align: 'left',
      render: (id, record) => (
        <div>
         {record.tiempoFinalizado != undefined ? secondsToHms(record.tiempoFinalizado) : "-"}
        </div>
      ),
    },
    {
      title:  (
        <div>
          Cumplimiento
        </div>
      ),
      dataIndex: 'cumplimiento',
      align: 'left',
      sorter: (a, b) => a.cumplimiento - b.cumplimiento,
      render: (id, record) => (
        <div>
         {record.cumplimiento}%
        </div>
      ),
    },
  ];

  const columnsTopics = [
    {
      title: 'Topics',
      dataIndex: 'nombre',
      align: 'center',
    },
    {
      title: 'Abiertos',
      dataIndex: 'abiertos',
      sorter: (a, b) => a.abiertos - b.abiertos,
    },
    {
      title: 'Asignados',
      dataIndex: 'asignados',
      sorter: (a, b) => a.asignados - b.asignados,
    },
    {
      title: 'Atrasados',
      dataIndex: 'atrasados',
      sorter: (a, b) => a.atrasados - b.atrasados,
    },
    {
      title: 'Finalizados',
      dataIndex: 'finalizados',
      sorter: (a, b) => a.finalizados - b.finalizados,
    },
    {
      title: 'Tickets',
      dataIndex: 'totalTicket',
      sorter: (a, b) => a.totalTicket - b.totalTicket,
    },
    {
      title:  (
        <div>
          Cumplimiento
        </div>
      ),
      dataIndex: 'cumplimiento',
      align: 'left',
      sorter: (a, b) => a.cumplimiento - b.cumplimiento,
      render: (id, record) => (
        <div>
         {record.cumplimiento}%
        </div>
      ),
    },
  ];

  const columnsPersonal = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      align: 'center',
    },
    {
      title: 'Abiertos',
      dataIndex: 'abiertos',
      sorter: (a, b) => a.abiertos - b.abiertos,
    },
    {
      title: 'Atrasados',
      dataIndex: 'atrasados',
      sorter: (a, b) => a.atrasados - b.atrasados,
    },
    {
      title: 'Finalizados',
      dataIndex: 'finalizados',
      sorter: (a, b) => a.finalizados - b.finalizados,
    },
    {
      title: 'Tickets',
      dataIndex: 'totalTicket',
      sorter: (a, b) => a.totalTicket - b.totalTicket,
    },
    {
      title:  (
        <div>
          Cumplimiento
        </div>
      ),
      dataIndex: 'cumplimiento',
      align: 'left',
      sorter: (a, b) => a.cumplimiento - b.cumplimiento,
      render: (id, record) => (
        <div>
         {record.cumplimiento}%
        </div>
      ),
    },
  ];

  const columnsRestaurante = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      align: 'center',
    },
    {
      title: 'Abiertos',
      dataIndex: 'abiertos',
      sorter: (a, b) => a.abiertos - b.abiertos,
    },
    {
      title: 'Asignados',
      dataIndex: 'asignados',
      sorter: (a, b) => a.asignados - b.asignados,
    },
    {
      title: 'Atrasados',
      dataIndex: 'atrasados',
      sorter: (a, b) => a.atrasados - b.atrasados,
    },
    {
      title: 'Finalizados',
      dataIndex: 'finalizados',
      sorter: (a, b) => a.finalizados - b.finalizados,
    },
    {
      title: 'Tickets',
      dataIndex: 'totalTicket',
      sorter: (a, b) => a.totalTicket - b.totalTicket,
    },
    {
      title:  (
        <div>
          Cumplimiento
        </div>
      ),
      dataIndex: 'cumplimiento',
      align: 'left',
      sorter: (a, b) => a.cumplimiento - b.cumplimiento,
      render: (id, record) => (
        <div>
         {record.cumplimiento}%
        </div>
      ),
    },
  ];


  const options = {
    title: "",
    curveType: "function",
    legend: { position: "right" },
  };

  const optionss = {
    hAxis: {
      title: "Time",
    },
    vAxis: {
      title: "Popularity",
    },
    series: {
      1: { curveType: "function" },
    },
  };
  
  

  const exportToExcel = () => {
    console.log("activeTab", activeTab);

    let data = null;
    let nameFile = "";
    let encabezados = [];

    switch (activeTab) {
      case '1':
        data = dataDepartamento.map(item => {
          const { tiempoAsignarse, tiempoIniciar, tiempoFinalizado, ...rest } = item;
          return {
            ...rest,
            tiempoAsignarse: secondsToHms(tiempoAsignarse),
            tiempoIniciar: secondsToHms(tiempoIniciar),
            tiempoFinalizado: secondsToHms(tiempoFinalizado)
          };
        });
        nameFile = "Departamentos";
        encabezados = columns;
        console.log("data",data)
        break;
      case '2':
        data = dataTipificacion.map(item => {
          const { tiempoAsignarse, tiempoFinalizado, tiempoIniciar, ...rest } = item;
          return rest;
        });
        nameFile = "Topics";
        encabezados = columnsTopics;
        break;
      case '3':
        data = dataPersonal.map(item => {
          const { tiempoAsignarse, tiempoFinalizado, tiempoIniciar, ...rest } = item;
          return rest;
        });
        nameFile = "Personal";
        encabezados = columnsPersonal;
        break;
      case '4':
        data = dataRestaurante.map(item => {
          const { tiempoAsignarse, tiempoFinalizado, tiempoIniciar, ...rest } = item;
          return rest;
        });
        nameFile = "Restaurante";
        encabezados = columnsRestaurante;
        break;
      case '5':
        data = dataGerenteZona.map(item => {
          const { tiempoAsignarse, tiempoFinalizado, tiempoIniciar, ...rest } = item;
          return rest;
        });
        nameFile = "GerenteArea";
        encabezados = columnsRestaurante;
        break;
      default:
        data = dataDepartamento;
        nameFile = "Departamentos";
        encabezados = columns;
        break;
    }

    const headers = encabezados.map(column => {
      if (typeof column.title === 'object' && 'props' in column.title) {
        const element = column.title;
        const htmlString = renderToString(element);

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const bodyAsString = doc.body.innerHTML + '';

        const textWithoutLineBreak = bodyAsString.replace(/<br\s*\/?>/g, ' ');
        const textWithoutDiv = textWithoutLineBreak.replace(/<div\s+data-reactroot=".*?">/g, '');
        const textWithoutClosingDiv = textWithoutDiv.replace(/<\/div>/g, '');

        return textWithoutClosingDiv;
      }
      return column.title;
    });

    const rows = [headers];
    data.forEach(item => {
      const rowData = Object.values(item);
      rows.push(rowData);
    });

    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, sheet, nameFile);

    XLSX.writeFile(workbook, `${nameFile}Tickets.xlsx`);
  };




  return (
    <div className={styles.view}>
      <Header
        title="Actividad de Tickets"
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
        <div className={styles.contMain}>
          <div className={styles.contBuscador}>
          <span className={styles.spanPeriodo}>Período</span>
          <RangePicker format={customFormat} locale={locale} style={{
              width: "250px",
            }}
            
            onChange={onChangeFecha} />
            <span className={styles.spanPeriodo}>Período</span>
            <Select
                id={"idPeriodo"}
                defaultValue={periodo}
                style={{
                  width: 200,
                }}
                onChange={(value)=>{
                  setPeriodo(value)
                  /*let newArr = [...listPreguntas]; // copying the old datas array
                  newArr[key].type = value
                  if(value == "option"){
                    newArr[key].opciones = []
                    newArr[key].opciones.push({posicion:0,valor:""})
                  }else{
                    newArr[key].opciones = []
                  }

                  setListPreguntas(newArr);*/
                }}
              >
              <Option value="Hoy">Hoy</Option>
              <Option value="Ayer">Ayer</Option>
              <Option value="Últimos 7 días">Últimos 7 días</Option>
              <Option value="Últimos 30 días">Últimos 30 días</Option>
            </Select>

            <Button
                disabled={loading}
                onClick={() => {
                  var tipo = periodo
                  if(startDate != ""){
                    tipo = "fecha"
                  }
                  buscarTickets(tipo,startDate,endDate)
                }}
                size="large"
                type="primary"
                className={styles.driverAssign}
              >
                BUSCAR
              </Button>

              <Button
              style={{marginLeft:"20px"}}
              size="large"
              onClick={() => {
                exportToExcel()
              }}
              disabled={loading}
              type={'primary'}
              className={styles.driverAssign}>
                Exportar Excel
            </Button>
          </div>
          <Chart
              chartType="LineChart"
              width="100%"
              height="400px"
              data={datagrafica}
              options={options}
            />

            <div className={styles.espacio}></div>
            <div>
              <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={handleTabChange}>
                <TabPane tab="DEPARTAMENTOS" key="1">
                  <Table
                    columns={columns}
                    rowKey="id"
                    dataSource={dataDepartamento}
                    pagination={false} 
                    ref={tableDepartamentosRef}
                  />
                </TabPane>
                <TabPane tab="TOPICS" key="2">
                  <Table
                      columns={columnsTopics}
                      rowKey="id"
                      dataSource={dataTipificacion}
                      pagination={{ defaultPageSize: 7 }}
                      ref={tableTopicsRef}
                    />
                </TabPane>
                <TabPane tab="PERSONAL" key="3">
                  <Table
                      columns={columnsPersonal}
                      rowKey="id"
                      dataSource={dataPersonal}
                      pagination={{ defaultPageSize: 7 }}
                      ref={tablePersonalRef}

                    />
                </TabPane>
                <TabPane tab="RESTAURANTES" key="4">
                  <Table
                      columns={columnsRestaurante}
                      rowKey="id"
                      dataSource={dataRestaurante}
                      pagination={{ defaultPageSize: 7 }}
                      ref={tableRestauranteRef}

                    />
                </TabPane>
                <TabPane tab="GERENTES DE AREA" key="5">
                  <Table
                      columns={columnsRestaurante}
                      rowKey="id"
                      dataSource={dataGerenteZona}
                      pagination={{ defaultPageSize: 7 }}
                      ref={tableGerenteAreaRef}

                    />
                </TabPane>
              </Tabs>
            </div>
          
            <div className={styles.espacio}></div>
        </div>
       


        </div>
      )}
      
    </div>
  );
};

export default HomeUI;
